export default __webpack_public_path__ + "media/images/placeholders/pumpkins-52322590728da8723c4a04343bbcc292.jpg";